<template>
  <div class="already-running">
    <div class="content">
      <RoutineLogoIcon :is-colored="true" class="logo" />
      <h2 class="title">Routine is already running</h2>
      <p class="message">
        Routine is already open in another tab or window. Please close other
        instances and refresh this page to continue.
      </p>
      <p class="help-text">Running multiple instances is not yet supported.</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import RoutineLogoIcon from "@/components/icons/RoutineLogoIcon.vue";

export default defineComponent({
  name: "AlreadyRunning",
  components: {
    RoutineLogoIcon,
  },
});
</script>

<style scoped lang="scss">
.already-running {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .logo {
    width: 65px;
    height: 33px;
    margin-bottom: 24px;
  }

  .title {
    margin: 12px 0;
    @extend %font-h3;
  }

  .message {
    margin: 0 0 16px 0;
    max-width: 420px;
    @extend %font-body-regular;
    line-height: 1.5;
    @include themed() {
      color: t($grey-70);
    }
  }

  .help-text {
    margin: 0;
    max-width: 420px;
    @extend %font-small-regular;
    line-height: 1.5;
    @include themed() {
      color: t($grey-50);
    }
  }
}
</style>
